import { useQuery } from "@tanstack/react-query";
import { productTranslationsService } from "./productTranslationsService";

export const useProductTranslationsQuery = () => {
	const { data, isLoading } = useQuery({
		queryKey: productTranslationsService.overviewKey,
		queryFn: () => productTranslationsService.overview().then((r) => r.data.data),
	});

	return {
		data,
		isLoading,
	};
};
